import { CmblAddress } from './cmbl-address.model';

export class ReverseGeocodingResult {
  result: CmblAddress | null;

  public static fromDto(d: any): ReverseGeocodingResult {
    if (!d) {
      return null;
    }

    const result = new ReverseGeocodingResult();

    result.result = CmblAddress.fromDto(d.result);

    return result;
  }
}
